import { RSetBase } from '@rimbu/collection-types/set-custom';
import { OrderedSetBuilder, OrderedSetEmpty, OrderedSetNonEmpty, } from '@rimbu/ordered/set-custom';
export class OrderedSetContextImpl extends RSetBase.ContextBase {
    constructor(listContext, setContext) {
        super();
        this.listContext = listContext;
        this.setContext = setContext;
        this.typeTag = 'OrderedSet';
        this._empty = Object.freeze(new OrderedSetEmpty(this));
        this.builder = () => {
            return new OrderedSetBuilder(this);
        };
    }
    isNonEmptyInstance(source) {
        return source instanceof OrderedSetNonEmpty;
    }
    isValidValue(value) {
        return this.setContext.isValidValue(value);
    }
    createBuilder(source) {
        return new OrderedSetBuilder(this, source);
    }
    createNonEmpty(order, sourceSet) {
        return new OrderedSetNonEmpty(this, order, sourceSet);
    }
}
//# sourceMappingURL=context.mjs.map